import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Collapse from '@material-ui/core/Collapse';

const useStyles = makeStyles((theme) => ({
   root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 'fit-content',
      marginTop: 0, //
      marginBottom: 10,
      margin: theme.spacing(3) //
   },
   avatar: {
      width: 60,
      height: 60,
      color: theme.palette.getContrastText(theme.palette.primary.main),
      backgroundColor: theme.palette.primary.main
   },
   name: {
      marginTop: theme.spacing(1)
   }
}));

/**
 * Perfil simple de un `usuario`, el cual muestra una imagen proporcionada mediante URI o las iniciales del nombre y apellido del usuario; el nombre y apellido del usuario; y el titulo del usuario.
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [Avatar](https://material-ui.com/api/avatar/)
 */
function Perfil({usuario, mapaUsuario, contenedorProps, onlyAvatar, className, ...rest}) {
   const classes = useStyles();
   const nombre = usuario[mapaUsuario.nombre] ? usuario[mapaUsuario.nombre] : '';
   const apellido = usuario[mapaUsuario.apellido] ? usuario[mapaUsuario.apellido] : '';
   const avatarProps = {
      ...rest,
      alt: 'Person',
      className: clsx(classes.avatar, className),
      src: usuario[mapaUsuario.avatarSrc],
      children: usuario[mapaUsuario.avatarSrc]
         ? undefined
         : `${nombre.substring(0, 1).toUpperCase()}${apellido.substring(0, 1).toUpperCase()}`
   };
   return (
      <div className={clsx(classes.root)} {...contenedorProps}>
         <Avatar {...avatarProps} />
         <Collapse in={!onlyAvatar}>
            <Typography className={classes.name} variant="h4">
               {`${nombre} ${apellido}`}
            </Typography>
            <Typography variant="body2" align="center">
               {usuario[mapaUsuario.titulo]}
            </Typography>
         </Collapse>
      </div>
   );
}

Perfil.propTypes = {
   /**
    * Propiedades del contenedor div
    */
   contenedorProps: PropTypes.object,
   /**
    * Informacion del usuario al que representa el perfil
    */
   usuario: PropTypes.object.isRequired,
   /**
    * Equivalencia de las propiedades usadas por el componente y las proporcionados por la propiedad `usuario`, donde:
    *
    * - `avatarSrc`: Propiedad de `usuario` que contine un link a la imagen del avatar.
    * - `nombre`: Propiedad de `usuario` que contine el nombre del usuario.
    * - `apellido`: Propiedad de `usuario` que contine el apellido del.
    * - `titulo`: Propiedad de `usuario` que contine el titulo por el cual es reconocido el usuaio.
    */
   mapaUsuario: PropTypes.shape({
      avatarSrc: PropTypes.string,
      nombre: PropTypes.string,
      apellido: PropTypes.string,
      titulo: PropTypes.string
   }),
   /**
    * Si __true__, solo se mostrar el avatar sin ningun otro tipo de información proporcionada por `usuario`
    */
   onlyAvatar: PropTypes.bool,
   /**
    * Propiedades del elemento html `div` contenedor del componente.
    */
   contenedorProps: PropTypes.object
};

Perfil.defaultProps = {
   mapaUsuario: {
      avatarSrc: 'avatarSrc',
      nombre: 'nombre',
      apellido: 'apellido',
      titulo: 'titulo'
   },
   onlyAvatar: false
};

export default Perfil;
